import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { formatApiError } from "@/lib/adminApi";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (ex) {
      setErr(formatApiError(ex?.response?.data?.detail) || "تعذّر الدخول.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-navy text-white px-6" dir="rtl">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-coral/20 mb-4">
            <Lock size={22} />
          </div>
          <h1 className="font-display text-2xl">لوحة إدارة سياق</h1>
          <p className="mt-2 text-white/70 text-sm">دخول محصور بالإدارة فقط.</p>
        </div>
        <form
          onSubmit={submit}
          className="bg-white/5 border border-white/10 p-6 space-y-4"
          data-testid="admin-login-form"
        >
          <div>
            <label htmlFor="email" className="block text-sm mb-2">البريد الإلكتروني</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              dir="ltr"
              className="w-full bg-white/5 border border-white/20 px-3 py-2.5 text-right"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              required
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm mb-2">كلمة المرور</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              className="w-full bg-white/5 border border-white/20 px-3 py-2.5"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              required
            />
          </div>
          {err && (
            <div className="text-sm border border-coral/60 text-coral px-3 py-2" role="alert">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full bg-coral text-white py-3 font-semibold disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            {busy ? <><Loader2 size={16} className="animate-spin" /> جارٍ الدخول…</> : "دخول"}
          </button>
        </form>
      </div>
    </div>
  );
}
